<template>
  <m-dialog
    :value="showReleaseNotes"
    max-width="64rem"
    no-padding
    hide-header
    hide-footer
    center
    fade-in
    max-height="calc(var(--viewport-height-100) - 3.2rem)"
    @close="closeReleaseNotes"
  >
    <release-notes-wrapper
      :release-notes="releaseNotes"
      :state="releaseNotesState"
      :unread-release-note-ids="unreadReleaseNotes.map((releaseNote) => releaseNote._id)"
      @close="closeReleaseNotes"
    />
  </m-dialog>
</template>

<script>
import ReleaseNotesWrapper from '@/release-notes/ReleaseNotesWrapper.vue';
import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import usePersonalAppSettings from '@/composables/logged-in-user/personal-app-settings';
import useReleaseNotes, { RELEASE_NOTES_STATE } from '@/composables/release-notes/release-notes';
import useSnackBar from '@/composables/snackbar';
import { EventBus } from '@/lib/event-bus';
import { logCatch } from '@/lib/logger/logger';

export default {
  name: 'ReleaseNotesDialog',
  components: { ReleaseNotesWrapper },
  data() {
    return { showReleaseNotes: false };
  },
  setup() {
    const snackbar = useSnackBar();

    const { loggedInUser } = useLoggedInUser();
    const personalAppSettingsSvc = usePersonalAppSettings(loggedInUser);
    const { releaseNotes, releaseNotesState, unreadReleaseNotes, markAsRead, fetchReleaseNotes } = useReleaseNotes(personalAppSettingsSvc, loggedInUser);
    return {
      snackbar,
      releaseNotes,
      releaseNotesState,
      unreadReleaseNotes,
      markAsRead,
      fetchReleaseNotes,
    };
  },
  methods: {
    closeReleaseNotes() {
      this.showReleaseNotes = false;
      if (this.releaseNotes.length === 0) {
        return;
      }
      this.markAsRead().catch(logCatch(() => {
        this.snackbar.error();
      }));
    },
    show() {
      this.showReleaseNotes = true;
      if (this.releaseNotesState === RELEASE_NOTES_STATE.failed) {
        this.fetchReleaseNotes().catch(logCatch(() => {}));
      }
    },
  },
  watch: {
    $route() {
      this.showReleaseNotes = false;
    },
  },
  created() {
    EventBus.$on('show-release-notes', this.show);
    this.fetchReleaseNotes().catch(logCatch(() => {}));
  },
  beforeUnmount() {
    EventBus.$off('show-release-notes', this.show);
  },
};
</script>
